import { pxToRem, pxTovW } from 'libs/shared-ui/src/commonUtils/resizeUtils';

import { Box, Typography, useMediaQuery } from '@mui/material';
import { ImageWrapper, theme } from '@geneo2-web/shared-ui';

interface IAddFromQuestionBankProps {
  onClick: () => void;
}
export const AddFromQuestionBank = (props: IAddFromQuestionBankProps) => {
  const { onClick } = props;

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Box
      sx={{
        width: { xs: '100%', md: '100%' },
        display: 'flex',
        gap: { xs: pxToRem(5), md: pxTovW(13) },
        background: '#D2EBFF',
        borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <ImageWrapper
        name="questionBank"
        type="png"
        parentFolder="icons"
        styles={{
          width: { xs: pxToRem(65), md: pxTovW(110), lg: pxTovW(81) },
          height: 'auto',
          marginY: 'auto',
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginY: 'auto',
          gap: { xs: pxToRem(4), md: pxTovW(5) },
        }}
      >
        <Box
          sx={{
            width: 'max-content',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#1674BF',
            padding: {
              xs: `${pxToRem(3)} ${pxToRem(12)} ${pxToRem(4)}`,
              md: `${pxTovW(5)} ${pxTovW(15)} ${pxTovW(6)}`,
            },
            borderRadius: {
              xs: pxToRem(10),
              md: pxTovW(20),
              lg: pxTovW(17),
            },
          }}
        >
          <Typography
            variant="smallText"
            color={'common.white'}
            fontWeight={'600'}
          >
            1000+ Questions
          </Typography>
        </Box>
        <Typography
          variant={isMobile ? 'h3' : isIpad ? 'h5' : 'h4'}
          fontWeight={'600'}
          fontFamily={'poppins'}
        >
          Add from Question Bank
        </Typography>
      </Box>

      <Box
        sx={{
          marginLeft: 'auto',
          marginY: 'auto',
          marginRight: { xs: pxToRem(15), md: pxTovW(20) },
        }}
      >
        <ImageWrapper
          styles={{
            width: { xs: pxToRem(23), md: pxTovW(30) },
            height: { xs: pxToRem(24), md: pxTovW(30) },
          }}
          name="right-arrow-circle"
          type="png"
          parentFolder="illustrations"
        />
      </Box>
    </Box>
  );
};
